import { React, useEffect, useState } from "react";
import NavBarV2 from "../../../NavBarV2";
import Card from "react-bootstrap/Card";
import Paper from "@mui/material/Paper";
import AddIcon from "@mui/icons-material/Add";
import TableContainer from "@mui/material/TableContainer";
import Tab from "@mui/material/Tab";
// import Button from "react-bootstrap/Button";
import DashboardLogo from "../../../../assets/dashboard1.svg";
import CloudIcon from "@mui/icons-material/Cloud";
import CardContent from "@mui/material/CardContent";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { InputAdornment, TextField } from "@mui/material";
import Table from "react-bootstrap/Table";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import "../../../../WorkSpace/SignUp2.css";
// import AddCompanyModal from "../../Modal/editCompanyModal";
import "../../../../WorkSpace/font.css";
// import { motion } from "motion/react"
import { motion } from "framer-motion";
import Tabsystem from "../../../Workspace-v2/Tabsystem";
import Tabs from "@mui/material/Tabs";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Popover from "@mui/material/Popover";
import TableRow from "@mui/material/TableRow";
import PropTypes from "prop-types";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Navbar } from "../../../../Components/Navbar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import swal from "sweetalert";
import InvestmentModal from "../../Modal/investmentModal";
import {
  getProjects,
  IrRegister,
} from "../../../../Console/Component/services/apiHandler";
import Autocomplete from "@mui/material/Autocomplete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  GetAllCompanyData,
  GetProject,
  cities,
  createDuplicate,
  deleteIr,
  deletePreset,
  fetchCoa,
  fetchCoaById,
  state,
  GetReceivable,
  GetPayable,
  GetSale,
  GetPurchase,
  GetFixedAsset,
  getActivePlan,
  renameInvestmentRegister,
  softDeleteLeaseRegister,
  GetLease,
  deleteInvestment,
} from "../../ApiServices/apiHandler";
import NestedModal from "../../Modal/addAccount";
import RegisterModal from "../../Modal/RegisterModal";
import moment from "moment";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import axios from "axios";
import * as actionTypes from "../../../../redux/actionTypes";
import ShareScreen from "../../../../Components/shareScreen/ShareScreen";
import PaginationRounded from "../../../../Components/Common/Pagination/Pagination";

import commoncss from "../../../../myfin_v2/css/common.module.css";
import workspacecss from "../../../../myfin_v2/css/workspace.module.css";
import buttoncss from "../../../../myfin_v2/css/button.module.css";
import wsCreationcss from "../../../../myfin_v2/css/workspaceCreation.module.css";
import cardcss from "../../../../myfin_v2/css/card.module.css";
import { Button } from "../../../../myfin_v2/elements/Button";
import { ReactComponent as CreateWSCard } from "../../../../myfin_v2/assets/icons/create_ws_card.svg";
import { ReactComponent as SearchIcon } from "../../../../myfin_v2/assets/icons/search.svg";
import { ReactComponent as SortIcon } from "../../../../myfin_v2/assets/icons/sort.svg";
import { ReactComponent as ExpandIcon } from "../../../../myfin_v2/assets/icons/expand.svg";
import { ReactComponent as RightArrowIcon } from "../../../../myfin_v2/assets/icons/rightArrowEcl.svg";
import { ReactComponent as EditIcon } from "../../../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as MinimizeIcon } from "../../../../myfin_v2/assets/icons/minimize.svg";
import { ReactComponent as PlusIcon } from "../../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as DeletePrimaryIcon } from "../../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as DeleteRedIcon } from "../../../../myfin_v2/assets/icons/delete_red.svg";
import ApproverLeaseModal from "../../../../myfin_v2/components/leases/ApproverLeaseModal";

const styles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 250,
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  p: 4,
};

const IRTab = (props) => {
  const dispatch = useDispatch();
  const {
    nextStep,
    allIr,
    value,
    handleChange,
    a11yProps,
    CustomTabPanel,
    handleDuplicate,
    // id,
    loader,
    popClose,
    opentab,
    // anchorEl,
    handleClosetab,
    // handleClick,
    // handleClose,
    allInvestRegister,
    multipleCompany,
    countCompany,
    setAddCompany,
    handleAllCompany,
    addCompanyshow,
    style,
    addCompany,
    setAnchorEl3,
    anchorEl3,
    handleShareScreen,
    oneCheckWorkspace,
    setOneCheckWorkspace,
    presetsData,
    insideWorskpace,
    workspaceID,
    setAllIR,
    userAccessIr,
    setLoan,
    loansData,
    loan,
    lease,
    setLease,
    leasesData,
    checkLoandata,
    checkedLoans,
    checkedLeases,
    setCheckLeasedata,
    setCheckLoandata,
    checkLeasedata,
    checkReceivabledata,
    checkPaybledata,
    checkSaledata,
    checkFixedAssetdata,
    checkPurchasedata,
    checkInvestmentdata,
    setCheckInvestmentdata,
    checkedInvestment,
    deleteInvestmentRegisters,
    getAll,
    getAllIrData,
    handleDeleteLease,
    isVerticalOrientation,
    LeaseData
  } = props;

  const user = JSON.parse(localStorage.getItem('user'));
  let permissions = JSON.parse(localStorage.getItem('permission'));
  const [checkContinueBotton, setCheckContinueBotton] = useState(false);
  const [searchTerm, setSearchTerm] = useState([]);
  const [allProject, setAllProject] = useState([]);
  const [allCoaData, setAllCoa] = useState([]);
  const [checkCoa, SetCheckCoa] = useState([]);
  const [allcities, setCitiesData] = useState([]);
  const [allstate, setStateData] = useState([]);
  const [openInvest, setOpenInvest] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [registerModalOpen, setRegisterModalOpen] = useState(false);
  const [allCompany, setAllCompany] = useState([]);
  const [anchorEl4, setAnchorEl4] = useState(null);
  const [presetId, setPresetID] = useState(null);
  const [anchorEl5, setAnchorEl5] = useState(null);
  const [Irid, setId] = useState("");
  const [IrDataID, setIRId] = useState("");
  const [receivable, setReceivable] = useState([]);
  const [payable, setPayable] = useState([]);
  const [sale, setSale] = useState([]);
  const [fixedAsset, setFixedAsset] = useState([]);
  const [purchase, setPurchase] = useState([]);
  const [paginateData, setPaginateData] = useState({
    all_coa: [],
  });
  const [checkedCoa, setCheckedCoa] = useState({
    all_coa: [],
  });
  const [pageData, setPageData] = useState({
    all_project: [],
  });
  const [receivableData, setReceivableData] = useState({
    all_receivable: [],
  });
  const [paybleData, setPaybleData] = useState({
    all_payble: [],
  });
  const [saleData, setSaleData] = useState({
    all_sale: [],
  });
  const [purchaseData, setPurchaseData] = useState({
    all_purchase: [],
  });
  const [fixedAssetData, setFixedAssetData] = useState({
    all_fixedAssets: [],
  });
  const [activePlandata, setActiveplanData] = useState([]);
  const [openRenameModal, setOpenRenameModal] = useState(false);
  const [updatedIRName, setUpdatedIRName] = useState("");
  const [leaseCompanyId, setLeaseCompanyId] = useState(null);
  const [regId, setRegId] = useState(null);
  const [approverId, setApproverId] = useState(null);
  const [approverLeaseModal, setApproverLeaseModal] = useState(false);

  const open = Boolean(anchorEl3);
  const id = open ? "simple-popover" : undefined;

  const open4 = Boolean(anchorEl4);
  const id4 = open4 ? "simple-popover" : undefined;

  const open5 = Boolean(anchorEl5);
  const id5 = open5 ? "simple-popover" : undefined;
  const history = useHistory();
  useEffect(() => {
    activePlan();
    AllProject();
    companyData();
    allCoa();
    allCheckedCoa();
    ReceivableData();
    PayableData();
    SaleData();
    PurchaseData();
    FixedAssetData();
  }, []);

  useEffect(() => {
    const IRName = allIr.filter((adj) => adj._id === IrDataID);
    setUpdatedIRName(IRName[0]?.name || "NA");
  }, [IrDataID, allIr]);

  const handleCloseModal = () => {
    setOpenInvest(false);
  };

  const companyData = async () => {
    try {
      const res = await GetAllCompanyData();
      if (res.status === 200) {
        setAllCompany(res.data.getAllCompanyData);
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const handleChangeData = (field, data) => {
    if (data.length > 0) {
      setCheckContinueBotton(true);
    }

    setSearchTerm([...searchTerm, data]);
  };

  const citiesData = async () => {
    const rescities = await cities();
    const citiesall = rescities.data.CitiesData.cities.map((data) => data.name);
    setCitiesData(citiesall);
  };
  const onInputChangecity = (event, value) => {
    if (value && value.length > 3) {
      citiesData();
    } else {
      setCitiesData([]);
    }
  };
  const handleOpenInvestment = () => {
    setOpenInvest(true);
  };
  const stateData = async () => {
    const res = await state();
    const stateall = res.data.StateData.state.map((data) => data.name);
    setStateData(stateall);
  };
  const onInputChange = (event, value) => {
    if (value && value.length > 3) {
      stateData();
    } else {
      setStateData([]);
    }
  };

  const handleRegisterModalOpen = () => {
    if (
      user.responsibilities === "approver" ||
      user.responsibilities === "view"
    ) {
      swal("Warning", "You Don't have Access to Create", "warning");
    } else {
      setRegisterModalOpen(true);
    }
  };

  const handleRegisterModalClose = () => {
    setRegisterModalOpen(false);
  };

  const handleOpen2 = () => {
    setOpen2(true);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };

  const AllProject = async () => {
    const res = await getProjects();
    if (res.status === 200) {
      // setAllProject(res.data.project);
      setPageData({ ...pageData, all_project: res.data.project });
    }
  };

  const CompanyName = (c_id) => {
    try {
      const nameCompany = allCompany.filter((adj) => adj._id === c_id);
      const result = nameCompany[0]?.company_name
        ? nameCompany[0]?.company_name
        : "";
      return result;
    } catch (error) {
      console.log(error, "2222");
      return 0;
    }
  };

  const allCoa = async () => {
    const res = await fetchCoa();
    if (res.status === 200) {
      // setAllCoa(res.data.coa);
      setPaginateData({ ...paginateData, all_coa: res.data.coa });
    }
  };

  const allCheckedCoa = async () => {
    const res = await fetchCoaById(workspaceID[2]);
    if (res.status === 200) {
      // SetCheckCoa(res.data.coa);
      setCheckedCoa({ ...checkedCoa, all_coa: res.data.coa });
    }
  };

  const CompanyType = (p_id, field) => {
    try {
      if (field === "company_type") {
        const nameOfType = pageData.all_project.filter(
          (adj) => adj._id === p_id
        );
        const result = nameOfType[0]?.company_type
          ? nameOfType[0]?.company_type
          : "";
        return result;
      } else if (field === "name") {
        const nameOfType = pageData.all_project.filter(
          (adj) => adj._id === p_id
        );
        const result = nameOfType[0]?.project_name
          ? nameOfType[0]?.project_name
          : "";
        return result;
      } else if (field === "current_yr") {
        const nameOfType = pageData.all_project.filter(
          (adj) => adj._id === p_id
        );
        const result = nameOfType[0]?.current_year
          ? nameOfType[0]?.current_year
          : "";
        return result;
      } else if (field === "previous_yr") {
        const nameOfType = pageData.all_project.filter(
          (adj) => adj._id === p_id
        );
        const result = nameOfType[0]?.previous_year
          ? nameOfType[0]?.previous_year
          : "";
        return result;
      } else if (field === "company_id") {
        const nameCompany = pageData.all_project.filter(
          (adj) => adj._id === p_id
        );
        return nameCompany[0]?.company ? nameCompany[0]?.company : "null";
      } else {
        const nameCompany = pageData.all_project.filter(
          (adj) => adj._id === p_id
        );
        const result = nameCompany[0]?.company ? nameCompany[0]?.company : "";
        const companyname = allCompany.filter((adj) => adj._id === result);
        const resultName = companyname[0]?.company_name
          ? companyname[0]?.company_name
          : "";
        return resultName;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const detailsIr = (_id) => {
    history.push(`/detailsIR/${_id}`);
  };

  const handleEditIr = (event, investmentID) => {
    if (event?.stopPropagation) event.stopPropagation();
    if (!investmentID) {
      console.error("[IRTab] Missing investmentID for edit navigation");
      return;
    }
    console.log("[IRTab] Navigating to edit register with investmentID:", investmentID);
    history.push(`/edit-investment/${investmentID}`);
  };
  const handleClick = (event, id, _id) => {
    setAnchorEl3(event.currentTarget);
    setId(id);
    setIRId(_id);
  };

  const handleOpenRenameModal = () => {
    if (
      user.responsibilities === "approver" ||
      user.responsibilities === "view"
    ) {
      swal("warning", "You don't have access to duplicate", "warning");
    } else {
      setOpenRenameModal(true);
    }
  };
  const handleCloseRenameModal = () => {
    setOpenRenameModal(false);
    setAnchorEl3(null);
  };

  const handleClick4 = (event, preset_id) => {
    setAnchorEl4(event.currentTarget);
    setPresetID(preset_id);
  };
  const handleClose = () => {
    setAnchorEl3(null);
    setId();
    setAnchorEl5(null);
    setAnchorEl4(null);
  };
  const handleClickCoa = (event, coa_id) => {
    setAnchorEl5(event.currentTarget);
  };

  const handleDeleteIr = async (Ir_id) => {
    const res = await deleteIr(Ir_id);
    if (res.status === 200) {
      setAllIR();
      setAnchorEl3(null);
    }
  };

  const handleDeleteInvestment = async (investmentId) => {
  swal({
    title: "Are you sure?",
    text: "This investment register will be permanently deleted",
    buttons: ["Cancel", "Delete"],
    dangerMode: true,
  }).then(async (willDelete) => {
    if (willDelete) {
      try {
        const res = await deleteInvestment(investmentId);

        if (res.status === 200) {
          swal("Deleted!", "Investment deleted successfully", "success");

          // refresh list
          getAll();
          getAllIrData();
        }
      } catch (error) {
        swal("Error", "Delete failed", "error");
      }
    }
  });
};

  const handleAddIR = (_id) => {
    if (
      user.responsibilities === "approver" ||
      user.responsibilities === "view"
    ) {
      swal("warning", "You don't have access to add more Ir", "warning");
      return false;
    } else {
      history.push(`/insideworkspace/${_id}`);
    }
  };

  const handleDeletePreset = async (preset_id) => {
    if (
      user.responsibilities === "approver" ||
      user.responsibilities === "view"
    ) {
      swal("warning", "You don't have access to duplicate", "warning");
    } else {
      swal({
        title: "Are you sure?",
        text: "do you want to delete this Preset ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, archive it!",
        cancelButtonText: "No, cancel please!",
        closeOnConfirm: false,
        closeOnCancel: false,
      }).then(async (result) => {
        if (result === true) {
          const res = await deletePreset(preset_id);
          if (res.status === 200) {
            AllProject();
            setAnchorEl4(null);
          }
        }
      });
    }
  };

  const hash = allIr.reduce(
    (p, c) => (p[c._id] ? p[c._id].push(c) : (p[c._id] = [c]), p),
    {}
  );
  const newData = Object.keys(hash).map((k) => ({ _id: k, car: hash[k] }));
  // const newDataIR = Object.keys(userAccessIr()).map((k) => ({ _id: k, car: hash[k] }));

  const IRName = (_id, field) => {
    if (field === "name") {
      const nameOfType = allIr.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    } else if (field === "id") {
      const nameOfType = allIr.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?._id ? nameOfType[0]?._id : "NA";
      return result;
    } else {
      const nameOfType = allIr.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.parent_company_id
        ? nameOfType[0]?.parent_company_id
        : "NA";

      const companyName = allCompany.filter((adj) => adj._id === result);
      const result2 = nameOfType[0]?.companyData?.company_name
      ? nameOfType[0]?.companyData?.company_name
      : "NA";
      return result2;
    }
  };

  const InvestmentName = (_id, field) => {
    if (field === "name") {
      const nameOfType = allIr.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    } else if (field === "id") {
      const nameOfType = allIr.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?._id ? nameOfType[0]?._id : "NA";
      return result;
    } else {
      const nameOfType = allIr.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.parent_company_id
        ? nameOfType[0]?.parent_company_id
        : "NA";

      const companyName = allCompany.filter((adj) => adj._id === result);
      const result2 = companyName[0]?.company_name
        ? companyName[0]?.company_name
        : "NA";
      return result2;
    }
  };

  const LoanName = (_id, field) => {
    if (field === "name") {
      const nameOfType = loansData.all_loans.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    } else if (field === "company") {
      const nameOfType = loansData.all_loans.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.company ? nameOfType[0]?.company : "NA";
      return result;
    } else if (field === "startDate") {
      const nameOfType = loansData.all_loans.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.startDate ? nameOfType[0]?.startDate : "NA";
      return result;
    } else if (field === "endDate") {
      const nameOfType = loansData.all_loans.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.endDate ? nameOfType[0]?.endDate : "NA";
      return result;
    } else {
      const nameOfType = loansData.all_loans.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.endDate ? nameOfType[0]?.endDate : "NA";
      return result;
    }
  };

  const LeaseName = (_id, field) => {
    if (field === "name") {
      const nameOfType = leasesData.all_leases.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    } else if (field === "company") {
      const nameOfType = leasesData.all_leases.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.company ? nameOfType[0]?.company : "NA";
      return result;
    } else if (field === "createdAt") {
      const nameOfType = leasesData.all_leases.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.createdAt ? nameOfType[0]?.createdAt : "NA";
      return result;
    } else {
      const nameOfType = leasesData.all_leases.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.company ? nameOfType[0]?.company : "NA";
      return result;
    }
  };

  const FixedAssetName = (_id, field) => {
    const fa = fixedAssetData.all_fixedAssets.find((fa) => fa._id === _id);
    if (!fa) return "NA";

    switch (field) {
      case "name":
        return fa.name || "NA";

      case "company":
        return fa.companyData?.company_name || "NA";

      case "asOnDate":
        return fa.asOnDate || "NA";

      case "createdAt":
        return fa.createdAt || "NA";

      default:
        return fa.name || "NA";
    }
  };

  const ReceivableName = (_id, field) => {
    if (field === "name") {
      const nameOfType = receivableData.all_receivable.filter(
        (adj) => adj._id === _id
      );
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    } else if (field === "company") {
      const nameOfType = receivableData.all_receivable.filter(
        (adj) => adj._id === _id
      );
      const result = nameOfType[0]?.company ? nameOfType[0]?.company : "NA";
      return result;
    } else if (field === "asOnDate") {
      const nameOfType = receivableData.all_receivable.filter(
        (adj) => adj._id === _id
      );
      const result = nameOfType[0]?.asOnDate ? nameOfType[0]?.asOnDate : "NA";
      return result;
    } else if (field === "createdAt") {
      const nameOfType = receivableData.all_receivable.filter(
        (adj) => adj._id === _id
      );
      const result = nameOfType[0]?.createdAt ? nameOfType[0]?.createdAt : "NA";
      return result;
    } else {
      const nameOfType = receivableData.all_receivable.filter(
        (adj) => adj._id === _id
      );
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    }
  };

  const PayableName = (_id, field) => {
    if (field === "name") {
      const nameOfType = paybleData.all_payble.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    } else if (field === "company") {
      const nameOfType = paybleData.all_payble.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.company ? nameOfType[0]?.company : "NA";
      return result;
    } else if (field === "asOnDate") {
      const nameOfType = paybleData.all_payble.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.asOnDate ? nameOfType[0]?.asOnDate : "NA";
      return result;
    } else if (field === "createdAt") {
      const nameOfType = paybleData.all_payble.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.createdAt ? nameOfType[0]?.createdAt : "NA";
      return result;
    } else {
      const nameOfType = paybleData.all_payble.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    }
  };

  const SaleName = (_id, field) => {
    if (field === "name") {
      const nameOfType = saleData.all_sale.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    } else if (field === "company") {
      const nameOfType = saleData.all_sale.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.company ? nameOfType[0]?.company : "NA";
      return result;
    } else if (field === "asOnDate") {
      const nameOfType = saleData.all_sale.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.asOnDate ? nameOfType[0]?.asOnDate : "NA";
      return result;
    } else if (field === "createdAt") {
      const nameOfType = saleData.all_sale.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.createdAt ? nameOfType[0]?.createdAt : "NA";
      return result;
    } else {
      const nameOfType = saleData.all_sale.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    }
  };

  const PurchaseName = (_id, field) => {
    if (field === "name") {
      const nameOfType = purchaseData.all_purchase.filter(
        (adj) => adj._id === _id
      );
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    } else if (field === "company") {
      const nameOfType = purchaseData.all_purchase.filter(
        (adj) => adj._id === _id
      );
      const result = nameOfType[0]?.company ? nameOfType[0]?.company : "NA";
      return result;
    } else if (field === "asOnDate") {
      const nameOfType = purchaseData.all_purchase.filter(
        (adj) => adj._id === _id
      );
      const result = nameOfType[0]?.asOnDate ? nameOfType[0]?.asOnDate : "NA";
      return result;
    } else if (field === "createdAt") {
      const nameOfType = purchaseData.all_purchase.filter(
        (adj) => adj._id === _id
      );
      const result = nameOfType[0]?.createdAt ? nameOfType[0]?.createdAt : "NA";
      return result;
    } else {
      const nameOfType = purchaseData.all_purchase.filter(
        (adj) => adj._id === _id
      );
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    }
  };

  const IRNameIR = (_id, field) => {
    if (field === "name") {
      const nameOfType = allInvestRegister.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.name ? nameOfType[0]?.name : "NA";
      return result;
    } else if (field === "id") {
      const nameOfType = allInvestRegister.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?._id ? nameOfType[0]?._id : "NA";
      return result;
    } else {
      const nameOfType = allInvestRegister.filter((adj) => adj._id === _id);
      const result = nameOfType[0]?.parent_company_id
        ? nameOfType[0]?.parent_company_id
        : "NA";

      const companyName = allCompany.filter((adj) => adj._id === result);
      const result2 = companyName[0]?.company_name
        ? companyName[0]?.company_name
        : "NA";
      return result2;
    }
  };

  function handleEnter(e, id) {
    const auth = localStorage.getItem("auth_token");
    let headers = {
      "x-auth-token": auth,
    };
    axios
      .get(`api/v1/tb-onboarding/get-tb/${id}`, { headers })
      .then((response) => {
        // dispatch({type: actionTypes.SET_RESTART,payload:'arr'})
        // dispatch({type: actionTypes.SET_NOTERESTART,payload:'arr'})
        console.log(response.data, "response response");
        dispatch({ type: actionTypes.SET_TB_ID, payload: response.data.tb_id });
        window.localStorage.setItem("tb_id", response.data.tb_id);
        localStorage.setItem("project_id", response.data.project_id);
        axios
          .get(`api/v1/grouping/fs/${id}`, { headers })
          .then((res) => {
            // if (res.data.fs_grp === []) {
            //   return;
            // }
            if (res.data.fs_grp.length === 0) {
              return;
            }
            const gp_data = {};
            gp_data.grp = res.data.fs_grp;
            dispatch({
              type: actionTypes.SET_EDITSUBGROUPING,
              payload: gp_data,
            });
          })
          .catch((error) => {
            console.log(error.response, "error");
          });
        history.push(`/createProject/DataMapping/${id}`);
      })
      .catch((error) => {
        console.log(error.response, "error");
        swal("", "Cannot found any TB inside this project", "error");
      });
  }

  const CoaName = (p_id) => {
    const nameOfCoa = allCoaData.filter((adj) => adj.project_id === p_id);
    const result = nameOfCoa[0]?.name ? nameOfCoa[0]?.name : "NA";
    return result;
  };

  //receivable//
  const ReceivableData = async () => {
    try {
      const res = await GetReceivable();
      if (res.status === 200) {
        // setReceivable(res.data.receivables);
        setReceivableData({
          ...receivableData,
          all_receivable: res.data.receivables,
        });
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  //payable//
  const PayableData = async () => {
    try {
      const res = await GetPayable();
      if (res.status === 200) {
        // setPayable(res.data.payables);
        setPaybleData({ ...paybleData, all_payble: res.data.payables });
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  //sale
  const SaleData = async () => {
    try {
      const res = await GetSale();
      if (res.status === 200) {
        setSaleData({ ...saleData, all_sale: res.data.sales });
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  //purchase
  const PurchaseData = async () => {
    try {
      const res = await GetPurchase();
      if (res.status === 200) {
        setPurchaseData({
          ...purchaseData,
          all_purchase: res.data.purchases,
        });
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };

  const FixedAssetData = async () => {
    try {
      const res = await GetFixedAsset();
      if (res.status === 200) {
        setFixedAssetData({
          ...fixedAssetData,
          all_fixedAssets: res.data.fixedAssets,
        });
      }
    } catch (error) {
      console.log(error.message, error);
    }
  };

  // show tabs according to active plans here
  const activePlan = async () => {
    try {
      const res = await getActivePlan();
      setActiveplanData(res.data?.categorizedBenefits?.dataset || "");
    } catch (error) {
      console.log(error.message);
    }
  };
  const getTabIndex = (name) => activePlandata.indexOf(name);
  // rename Investment register
  const handleRenameIr = (event) => {
    setUpdatedIRName(event.target.value);
  };

  const RenameIR = () => {
    const data = {
      name: updatedIRName,
    };
    renameInvestmentRegister(IrDataID, data)
      .then((response) => {
        handleCloseRenameModal();
        getAll();
        getAllIrData();
        userAccessIr();
        swal("Success", "IR Rename Successfully", "success");
      })
      .catch((error) => {
        swal("Error", "IR Rename Failed", "error");
      });
  };

  const [activeSection, setActiveSection] = useState("Leases");
  const [tabOrientation, setTabOrientation] = useState("horizontal");

  const routerHistory = useHistory();
  const handleClickNew = (Link) => {
    routerHistory.push(Link);
  };

  useEffect(() => {
    isVerticalOrientation(tabOrientation === "vertical" ? true : false);
  }, [tabOrientation])


  const handleLeaseRegisterDelete = (registerID) => {
    swal({
      title: "Are you sure?",
      text: "You can restore it from the bin",
      icon: "warning",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Yes, delete it!",
          value: true,
          className: `btnRed`
        },
      },
      closeOnClickOutside: false,
    }).then((willDelete) => {
      if (willDelete) {
        softDeleteLeaseRegister(registerID).then((response) => {
          swal({
            title: 'Deleted',
            text: 'Lease Register Deleted',
            icon: 'success'
          });
          GetLease().then((res) => {
            setLease(res.data.projects);
          });
        })
      }
    })
  }


  const sendForApproval = (approverID) => {
    const payload = {
      approvalStatus: "pending delete",
      approverID: approverID,
    };
    softDeleteLeaseRegister(regId, payload)
      .then((response) => {
        if (response?.data?.project) {
          swal("Success", "Approval for delete sent successfully.", 'success');
          setApproverLeaseModal(false);
        } else {
          swal(
            "Error", "Unable send for approval",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable send for approval",
          "error"
        );
      });
  };


  return (
    <>
      {/* <div className="row">
        <div
          className={
            allIr?.length > 0 || userAccessIr()?.length > 0 || loansData.all_loans.length > 0 || leasesData.all_leases.length > 0
              ? "col-md-8"
              : "col-md-12"
          }
        >
          <h5 className="dbwcardhead font-sans">Data Registers  </h5>
        </div>
        {loader ? (
          ""
        ) : allIr?.length > 0 || userAccessIr()?.length > 0 || loansData.all_loans.length > 0 || leasesData.all_leases.length > 0 ? (
          <div className="col-4 text-right">
            <button className="rwp-btn font-sans" onClick={handleRegisterModalOpen}>
              <span>
                <AddIcon />
              </span>
              Create New Register
            </button>
          </div>
        ) : (
          ""
        )}
      </div> */}
      <motion.div
        className={`${commoncss.dFlex}`}
        style={{
          position: "sticky",
          top: "0",
          zIndex: "10",
          padding: "15px 0px",
        }}
      >
        <span className={commoncss.heading2}>Data Registers</span>

        <span className={commoncss.dFlex}>
          <SortIcon className="mr-3" />
          {tabOrientation === "vertical" && (
            <MinimizeIcon
              className={commoncss.clickable}
              onClick={() => {
                setTabOrientation("horizontal");
              }}
            />
          )}
          {tabOrientation === "horizontal" && (
            <ExpandIcon
              className={commoncss.clickable}
              onClick={() => {
                setTabOrientation("vertical");
              }}
            />
          )}
          &ensp;&ensp;
          {loader ? (
            ""
          ) : allIr?.length > 0 || userAccessIr()?.length > 0 || loansData.all_loans.length > 0 || leasesData.all_leases.length > 0 ? (
            <>
              {((user.responsibilities === "preparer") || (user?.isAdmin === "Yes")) && (
                <>
                  <Button
                    icon={<DeletePrimaryIcon height={16} />}
                    btnColor={buttoncss.greyBg}
                    label={"Deleted Registers"}
                    onClick={() => history.push(`/deleted-registers`)}
                  />&nbsp;
                  <Button
                    icon={<PlusIcon />}
                    btnColor={buttoncss.primary}
                    label={"Create Register"}
                    onClick={handleRegisterModalOpen}
                  />
                </>
              )}

              {/* <Button
                icon={<PlusIcon />}
                btnColor={buttoncss.primary}
                label={"Create Register"}
                onClick={handleRegisterModalOpen}
              /> */}
            </>
          ) : (
            ""
          )}
        </span>
      </motion.div>

      {loader ? (
        ""
      ) : allIr?.length > 0 ||
      userAccessIr()?.length > 0 ||
      loansData?.all_loans?.length > 0 ||
      leasesData?.all_leases?.length > 0 ? (
        <div className="row">
          <div style={{ width: "100%", margin: "0px 10px" }}>
            <div
              className={`${workspacecss.dataRegisterDiv} ${workspacecss.scrollContainer}`}
              style={{
                display: "flex",
                flexDirection: "row",
                height: tabOrientation === "vertical" ? "86.5vh" : "51.5vh",
                overflow: "hidden",
              }}
            >
              <div
                className={`mb-2 ${workspacecss.scrollContainer}`}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: tabOrientation === "vertical" ? "160px" : "160px",
                  height: tabOrientation === "vertical" ? "86.5vh" : "51.5vh",
                  overflow: "auto",
                  borderRight: "1px solid #CCD5D3",
                }}
              >
                {activePlandata.includes("Leases") && (
                  <button
                    className={`${workspacecss.tabButton} ${
                      activeSection === "Leases" ? workspacecss.tabActive : ""
                    }`}
                    onClick={() => {
                      setActiveSection("Leases");
                      if (tabOrientation === "horizontal") {
                        setTabOrientation(
                          tabOrientation === "vertical"
                            ? "horizontal"
                            : "vertical"
                        );
                      }
                    }}
                    style={{
                      "text-transform": "capitalize",
                      "border-radius": "20px 0px 0px 0px",
                    }}
                  >
                    Leases
                  </button>
                )}
                {activePlandata.includes("Investment") && (
                  <button
                    className={`${workspacecss.tabButton} ${
                      activeSection === "Investments"
                        ? workspacecss.tabActive
                        : ""
                    }`}
                    onClick={() => {
                      setActiveSection("Investments");
                      if (tabOrientation === "horizontal") {
                        setTabOrientation(
                          tabOrientation === "vertical"
                            ? "horizontal"
                            : "vertical"
                        );
                      }
                    }}
                    style={{ "text-transform": "capitalize" }}
                  >
                    Investments
                  </button>
                )}

                {activePlandata.includes("Fixed Assets") && (
                  <button
                    className={`${workspacecss.tabButton} ${
                      activeSection === "Fixed Assets"
                        ? workspacecss.tabActive
                        : ""
                    }`}
                    onClick={() => {
                      setActiveSection("Fixed Assets");
                      if (tabOrientation === "horizontal") {
                        setTabOrientation(
                          tabOrientation === "vertical"
                            ? "horizontal"
                            : "vertical"
                        );
                      }
                    }}
                    style={{ "text-transform": "capitalize" }}
                  >
                    Fixed Assets
                  </button>
                )}

                {activePlandata.includes("Receivables") && (
                  <button
                    className={`${workspacecss.tabButton} ${
                      activeSection === "Receivables"
                        ? workspacecss.tabActive
                        : ""
                    }`}
                    onClick={() => {
                      setActiveSection("Receivables");
                      if (tabOrientation === "horizontal") {
                        setTabOrientation(
                          tabOrientation === "vertical"
                            ? "horizontal"
                            : "vertical"
                        );
                      }
                    }}
                    style={{ "text-transform": "capitalize" }}
                  >
                    Receivables
                  </button>
                )}

                {activePlandata.includes("Payables") && (
                  <button
                    className={`${workspacecss.tabButton} ${
                      activeSection === "Payables" ? workspacecss.tabActive : ""
                    }`}
                    onClick={() => {
                      setActiveSection("Payables");
                      if (tabOrientation === "horizontal") {
                        setTabOrientation(
                          tabOrientation === "vertical"
                            ? "horizontal"
                            : "vertical"
                        );
                      }
                    }}
                    style={{ "text-transform": "capitalize" }}
                  >
                    Payables
                  </button>
                )}

                {activePlandata.includes("Loans") && (
                  <button
                    className={`${workspacecss.tabButton} ${
                      activeSection === "Loans" ? workspacecss.tabActive : ""
                    }`}
                    onClick={() => {
                      setActiveSection("Loans");
                      if (tabOrientation === "horizontal") {
                        setTabOrientation(
                          tabOrientation === "vertical"
                            ? "horizontal"
                            : "vertical"
                        );
                      }
                    }}
                    style={{ "text-transform": "capitalize" }}
                  >
                    Loans
                  </button>
                )}

                {activePlandata.includes("COA") && (
                  <button
                    className={`${workspacecss.tabButton} ${
                      activeSection === "COA" ? workspacecss.tabActive : ""
                    }`}
                    onClick={() => {
                      setActiveSection("COA");
                      if (tabOrientation === "horizontal") {
                        setTabOrientation(
                          tabOrientation === "vertical"
                            ? "horizontal"
                            : "vertical"
                        );
                      }
                    }}
                    style={{ "text-transform": "capitalize" }}
                  >
                    COA
                  </button>
                )}

                {activePlandata.includes("Presets") && (
                  <button
                    className={`${workspacecss.tabButton} ${
                      activeSection === "Presets" ? workspacecss.tabActive : ""
                    }`}
                    onClick={() => {
                      setActiveSection("Presets");
                      if (tabOrientation === "horizontal") {
                        setTabOrientation(
                          tabOrientation === "vertical"
                            ? "horizontal"
                            : "vertical"
                        );
                      }
                    }}
                    style={{ "text-transform": "capitalize" }}
                  >
                    Presets
                  </button>
                )}

                {activePlandata.includes("Sales") && (
                  <button
                    className={`${workspacecss.tabButton} ${
                      activeSection === "Sales" ? workspacecss.tabActive : ""
                    }`}
                    onClick={() => {
                      setActiveSection("Sales");
                      if (tabOrientation === "horizontal") {
                        setTabOrientation(
                          tabOrientation === "vertical"
                            ? "horizontal"
                            : "vertical"
                        );
                      }
                    }}
                    style={{ "text-transform": "capitalize" }}
                  >
                    Sales
                  </button>
                )}
                {activePlandata.includes("Purchases") && (
                  <button
                    className={`${workspacecss.tabButton} ${
                      activeSection === "Purchases"
                        ? workspacecss.tabActive
                        : ""
                    }`}
                    onClick={() => {
                      setActiveSection("Purchases");
                      if (tabOrientation === "horizontal") {
                        setTabOrientation(
                          tabOrientation === "vertical"
                            ? "horizontal"
                            : "vertical"
                        );
                      }
                    }}
                    style={{ "text-transform": "capitalize" }}
                  >
                    Purchases
                  </button>
                )}

                {activePlandata.includes("Book closure") && (
                  <button
                    className={`${workspacecss.tabButton} ${
                      activeSection === "Book Closure"
                        ? workspacecss.tabActive
                        : ""
                    }`}
                    onClick={() => {
                      setActiveSection("Book Closure");
                      if (tabOrientation === "horizontal") {
                        setTabOrientation(
                          tabOrientation === "vertical"
                            ? "horizontal"
                            : "vertical"
                        );
                      }
                    }}
                    style={{ "text-transform": "capitalize" }}
                  >
                    Book Closure
                  </button>
                )}
              </div>

              <div
                className={`${workspacecss.scrollContainer} my-2`}
                style={{
                  flexGrow: 1,
                  height: tabOrientation === "vertical" ? "86.5vh" : "51.5vh",
                  overflow: "auto",
                }}
              >
                {activeSection === "COA" && (
                  <>
                    {insideWorskpace === "no" &&
                      paginateData?.all_coa?.length > 0 &&
                      paginateData?.all_coa?.map((coa) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      history.push({
                                        pathname: `/myfinV2/coa/listing/${coa.project_id}/${CompanyType(coa.project_id, "company_id")}`,
                                        state: { coaName: coa.name, coaLedgers: coa.coa }
                                      });
                                    }}
                                  >
                                    {coa.name}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {CompanyType(
                                      coa.project_id,
                                      "company_type"
                                    )}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {CompanyType(
                                      coa.project_id,
                                      "company_name"
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}

                    {insideWorskpace === "yes" &&
                      checkedCoa?.all_coa?.length > 0 &&
                      checkedCoa?.all_coa?.map((coa) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      history.push({
                                        pathname: `/myfinV2/coa/listing/${coa.project_id}/${CompanyType(coa.project_id, "company_id")}`,
                                        state: { coaName: coa.name, coaLedgers: coa.coa }
                                      });
                                    }}
                                  >
                                    {coa.name}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {CompanyType(
                                      coa.project_id,
                                      "company_type"
                                    )}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {CompanyType(
                                      coa.project_id,
                                      "company_name"
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    <div className="m-2" hidden>
                      {insideWorskpace === "no" ? (
                        <PaginationRounded
                          data={
                            paginateData.all_coa.length > 0 &&
                            paginateData.all_coa
                          }
                          setData={setAllCoa}
                        />
                      ) : (
                        <PaginationRounded
                          data={
                            checkedCoa.all_coa.length > 0 && checkedCoa.all_coa
                          }
                          setData={SetCheckCoa}
                        />
                      )}
                    </div>
                  </>
                )}
                {activeSection === "Loans" && (
                  <>
                    {insideWorskpace === "no" &&
                       loansData?.all_loans?.length > 0 &&
                       loansData.all_loans.map((loan) => {
                        return (
                          <div key={loan._id}>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      handleClickNew(
                                        `/myfinV2/loans/overview/${loan._id}/${loan.companyID}`
                                      );
                                    }}
                                  >
                                    {loan.name}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {loan.companyData?.company_name}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      Start date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(loan.startDate).format(
                                        "DD MMM YYYY"
                                      )}
                                    </span>
                                  </div>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      End date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(loan.endDate).format(
                                        "DD MMM YYYY"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                    {insideWorskpace === "yes" &&
                      checkLoandata.length > 0 &&
                      checkLoandata.map((loan) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => detailsIr(loan._id)}
                                  >
                                    {LoanName(loan, "name")}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {LoanName(loan, "company")}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      Start date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(
                                        LoanName(loan, "startDate")
                                      ).format("DD MMM YYYY")}
                                    </span>
                                  </div>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      End date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(LoanName(loan, "endDate")).format(
                                        "DD MMM YYYY"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    <div className="m-2" hidden>
                      {insideWorskpace === "no" ? (
                        <PaginationRounded
                          data={
                            loansData?.all_loans?.length > 0 &&
                            loansData.all_loans
                          }
                          setData={setLoan}
                        />
                      ) : (
                        <PaginationRounded
                          data={
                            checkedLoans.all_loans.length > 0 &&
                            checkedLoans.all_loans
                          }
                          setData={setCheckLoandata}
                        />
                      )}
                    </div>
                  </>
                )}

                {activeSection === "Payables" && (
                  <>
                    {insideWorskpace === "no" &&
                      paybleData.all_payble.length > 0 &&
                      paybleData.all_payble.map((payable) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      handleClickNew({
                                        pathname: `/myfinV2/payables/listing/${payable._id}/${payable.companyID}`,
                                        state: {
                                          asOnDate: payable.asOnDate,
                                          companyName: payable.companyData?.company_name,
                                          regName: payable.name,
                                        },
                                      });
                                    }}
                                  >
                                    {payable.name}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {payable.companyData?.company_name}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      As on date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(payable.asOnDate).format(
                                        "DD MMM YYYY"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    {insideWorskpace === "yes" &&
                      checkPaybledata.length > 0 &&
                      checkPaybledata.map((payable) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      handleClickNew(
                                        `/myfinV2/payables/listing/${payable._id}/${payable.companyID}`
                                      );
                                    }}
                                  >
                                    {PayableName(payable, "name")}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {PayableName(payable, "company")}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      As on date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(
                                        PayableName(payable, "asOnDate")
                                      ).format("DD MMM YYYY")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}

                    <div className="m-2" hidden>
                      {insideWorskpace === "no" ? (
                        <PaginationRounded
                          data={
                            paybleData.all_payble.length > 0 &&
                            paybleData.all_payble
                          }
                          setData={setPayable}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                )}

                {activeSection === "Receivables" && (
                  <>
                    {insideWorskpace === "no" &&
                      receivableData.all_receivable.length > 0 &&
                      receivableData.all_receivable.map((receivable) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      handleClickNew({
                                        pathname: `/myfinV2/receivables/listing/${receivable._id}/${receivable.companyID}`,
                                        state: {
                                          companyName:
                                            receivable.companyData
                                              ?.company_name,
                                          regName: receivable.name,
                                          asOnDate: receivable.asOnDate,
                                        },
                                      });
                                    }}
                                  >
                                    {receivable.name}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {receivable.companyData?.company_name}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      As on date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(receivable.asOnDate).format(
                                        "DD MMM YYYY"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    {insideWorskpace === "yes" &&
                      checkReceivabledata.length > 0 &&
                      checkReceivabledata.map((receivable) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      handleClickNew({
                                        pathname: `/myfinV2/receivables/listing/${receivable._id}/${receivable.companyID}`,
                                        state: {
                                          companyName: ReceivableName(
                                            receivable,
                                            "company"
                                          ),
                                          regName: ReceivableName(
                                            receivable,
                                            "name"
                                          ),
                                        },
                                      });
                                    }}
                                  >
                                    {ReceivableName(receivable, "name")}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {ReceivableName(receivable, "company")}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      As on date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(
                                        ReceivableName(receivable, "asOnDate")
                                      ).format("DD MMM YYYY")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    <div className="m-2" hidden>
                      {insideWorskpace === "no" ? (
                        <PaginationRounded
                          data={
                            receivableData.all_receivable.length > 0 &&
                            receivableData.all_receivable
                          }
                          setData={setReceivable}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                )}
                {activeSection === "Leases" && (
                  <>
                    {insideWorskpace === "no" &&
                      leasesData.all_leases.length > 0 &&
                      leasesData.all_leases.map((lease) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      window.location.href = `${process.env.REACT_APP_LEASE_FRONTEND_URL}overview/${lease._id}`;
                                    }}
                                  >
                                    {lease.name}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {lease.companyData.company_name}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ "gap": "20px", alignItems: "center" }}>
                                  {(user?.isAdmin === "Yes") && (
                                    <>
                                      <EditIcon height={16} style={{ cursor: 'pointer' }} onClick={() => history.push(`/edit-lease-register/${lease._id}`)} />
                                      <DeleteRedIcon height={16} style={{ cursor: 'pointer' }} onClick={() => handleLeaseRegisterDelete(lease._id)} />
                                    </>
                                  )}
                                  {(user.responsibilities === "preparer") && (
                                    <>


                                      {!lease.approvalStatus?.includes("pending") && (
                                        <>
                                          <EditIcon height={16} style={{ cursor: 'pointer' }} onClick={() => history.push(`/edit-lease-register/${lease._id}`)} />
                                          <DeleteRedIcon height={16} style={{ cursor: 'pointer' }} onClick={() => { setRegId(lease._id); setLeaseCompanyId(lease.companyData._id); setApproverLeaseModal(true) }} />
                                        </>
                                      )}

                                    </>
                                  )}
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      Created at
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(lease.createdAt).format(
                                        "DD MMM YYYY"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}

                    {insideWorskpace === "yes" &&
                      checkLeasedata.length > 0 &&
                      checkLeasedata.map((lease) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      window.location.href = `${process.env.REACT_APP_LEASE_FRONTEND_URL}/overview/${lease}`;
                                    }}
                                  >
                                    {LeaseName(lease, "name")}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {LeaseName(lease, "company")}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      Created at
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(lease.createdAt).format(
                                        "DD MMM YYYY"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}

                    <div className="m-2" hidden>
                      {insideWorskpace === "no" ? (
                        <PaginationRounded
                          data={
                            leasesData.all_leases.length > 0 &&
                            leasesData.all_leases
                          }
                          setData={setLease}
                        />
                      ) : (
                        <PaginationRounded
                          data={
                            checkedLeases.all_leases.length > 0 &&
                            checkedLeases.all_leases
                          }
                          setData={setCheckLeasedata}
                        />
                      )}
                    </div>
                  </>
                )}

                {activeSection === "Purchases" && (
                  <>
                    {insideWorskpace === "no" &&
                      purchaseData.all_purchase.length > 0 &&
                      purchaseData.all_purchase.map((purchase) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      handleClickNew(
                                        `/myfinV2/purchase/listing/${purchase._id}/${purchase.companyID}`
                                      );
                                    }}
                                  >
                                    {purchase.name}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {purchase.companyData?.company_name}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      As on date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(purchase.asOnDate).format(
                                        "DD MMM YYYY"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    {insideWorskpace === "yes" &&
                      checkPurchasedata.length > 0 &&
                      checkPurchasedata.map((purchase) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      handleClickNew(
                                        `/myfinV2/purchase/listing/${purchase._id}/${purchase.companyID}`
                                      );
                                    }}
                                  >
                                    {PurchaseName(purchase, "name")}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {PurchaseName(purchase, "company")}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      As on date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(
                                        PurchaseName(purchase, "asOnDate")
                                      ).format("DD MMM YYYY")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    <div className="m-2" hidden>
                      {insideWorskpace === "no" ? (
                        <PaginationRounded
                          data={
                            purchaseData.all_purchase.length > 0 &&
                            purchaseData.all_purchase
                          }
                          setData={setPurchase}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                )}

                {approverLeaseModal && regId && leaseCompanyId && (
                  <ApproverLeaseModal
                    setApproverLeaseModal={setApproverLeaseModal}
                    companyId={leaseCompanyId}
                    setApproverId={setApproverId}
                    sendForApproval={sendForApproval}
                  />
                )}

                {activeSection === "Investments" && (
                  <>
                    {insideWorskpace === "no" &&
                      userAccessIr()?.length > 0 &&
                      userAccessIr()?.map((invest, idx) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              key={idx}
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                 <div className={commoncss.dFlexClm}>
                                  <span className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`} onClick={invest[0]?._id ? () => { detailsIr(invest[0]?._id) } : () => { detailsIr(invest?._id) }}>
                                    {invest[0]?._id ? IRNameIR(invest[0]?._id, "name") : IRName(invest._id, "name")}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {invest[0]?._id
                                      ? IRNameIR(invest[0]?._id, "company")
                                      : IRName(invest._id, "company")}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px", alignItems: "center" }}>
                                  {(user?.isAdmin === "Yes" || user.responsibilities === "preparer") && (
                                    <>
                                      <EditIcon height={16} style={{ cursor: 'pointer' }} onClick={(e) => handleEditIr(e, invest[0]?._id || invest?._id)} />
                                      <DeleteRedIcon height={16} style={{ cursor: 'pointer' }} onClick={() => handleDeleteInvestment(invest[0]?._id || invest?._id)} />
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}

                    {insideWorskpace === "yes" &&
                      checkInvestmentdata?.length > 0 &&
                      checkInvestmentdata?.map((invest, idx) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              key={idx}
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                    <div className={commoncss.dFlexClm}>
                                  <span className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`} onClick={() => { detailsIr(invest) }}>
                                    {InvestmentName(invest, "name")}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {InvestmentName(invest, "company")}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px", alignItems: "center" }}>
                                  {(user?.isAdmin === "Yes" || user.responsibilities === "preparer") && (
                                    <>
                                      <EditIcon height={16} style={{ cursor: 'pointer' }} onClick={(e) => handleEditIr(e, invest)} />
                                      <DeleteRedIcon height={16} style={{ cursor: 'pointer' }} onClick={() => handleDeleteInvestment(invest)} />
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    <div className="m-2" hidden>
                      {insideWorskpace === "no" ? (
                        ""
                      ) : (
                        <PaginationRounded
                          data={
                            checkedInvestment.all_investments.length > 0 &&
                            checkedInvestment.all_investments
                          }
                          setData={setCheckInvestmentdata}
                        />
                      )}
                    </div>
                  </>
                )}

                {activeSection === "Sales" && (
                  <>
                    {insideWorskpace === "no" &&
                      saleData.all_sale.length > 0 &&
                      saleData.all_sale.map((sale) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      handleClickNew(
                                        `/myfinV2/sales/listing/${sale._id}/${sale.companyID}`
                                      );
                                    }}
                                  >
                                    {sale.name}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {sale.companyData?.company_name}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      As on date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(sale.asOnDate).format(
                                        "DD MMM YYYY"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    {insideWorskpace === "yes" &&
                      checkSaledata.length > 0 &&
                      checkSaledata.map((sale) => {
                        return (
                          <>
                            <div
                              className="d-flex px-4 py-1"
                              style={{ "align-items": "center" }}
                            >
                              <div
                                className={`${commoncss.dFlexJustifysb}`}
                                style={{
                                  width: "100%",
                                  "margin-bottom": "10px",
                                  "margin-top": "10px",
                                }}
                              >
                                <div className={commoncss.dFlexClm}>
                                  <span
                                    className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                    onClick={() => {
                                      handleClickNew(
                                        `/myfinV2/sales/listing/${sale._id}/${sale.companyID}`
                                      );
                                    }}
                                  >
                                    {SaleName(sale, "name")}
                                  </span>
                                  <span className={wsCreationcss.wscLabel3}>
                                    {SaleName(sale, "company")}
                                  </span>
                                </div>
                                <div className="d-flex" style={{ gap: "20px" }}>
                                  <div className={wsCreationcss.wscCard2}>
                                    <span className={wsCreationcss.wscLabel9}>
                                      As on date
                                    </span>
                                    <span className={wsCreationcss.wscLabel5}>
                                      {moment(
                                        SaleName(sale, "asOnDate")
                                      ).format("DD MMM YYYY")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    <div className="m-2" hidden>
                      {insideWorskpace === "no" ? (
                        <PaginationRounded
                          data={
                            saleData.all_sale.length > 0 && saleData.all_sale
                          }
                          setData={setSale}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                )}

                {activeSection === "Presets" && (
                  <>
                    {insideWorskpace === "no" &&
                      pageData?.all_project?.length > 0 &&
                      pageData?.all_project?.map((det) => (
                        <div
                          className="d-flex px-4 py-1"
                          style={{ "align-items": "center" }}
                        >
                          <div
                            className={`${commoncss.dFlexJustifysb}`}
                            style={{
                              width: "100%",
                              "margin-bottom": "10px",
                              "margin-top": "10px",
                            }}
                          >
                            <div className={commoncss.dFlexClm}>
                              <span className={wsCreationcss.wscLabel2}>
                                {det.project_name}
                              </span>
                              <span className={wsCreationcss.wscLabel3}>
                                {det.company_type}
                              </span>
                              <span className={wsCreationcss.wscLabel3}>
                                {CompanyName(det.company)}
                              </span>
                            </div>
                            <div className="d-flex" style={{ gap: "20px" }}>
                              <div className={wsCreationcss.wscCard2}>
                                <span className={wsCreationcss.wscLabel4}>
                                  Current Year
                                </span>
                                <span className={wsCreationcss.wscLabel5}>
                                  {moment(det.current_year).format(
                                    "DD MMM YYYY"
                                  )}
                                </span>
                              </div>
                              <div className={wsCreationcss.wscCard2}>
                                <span className={wsCreationcss.wscLabel4}>
                                  Previous Year
                                </span>
                                <span className={wsCreationcss.wscLabel5}>
                                  {moment(det.previous_year).format(
                                    "DD MMM YYYY"
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                    {insideWorskpace === "yes" &&
                      presetsData?.all_presets?.length > 0 &&
                      presetsData?.all_presets?.map((det) => (
                        <div
                          className="d-flex px-4 py-1"
                          style={{ "align-items": "center" }}
                        >
                          <div
                            className={`${commoncss.dFlexJustifysb}`}
                            style={{
                              width: "100%",
                              "margin-bottom": "10px",
                              "margin-top": "10px",
                            }}
                          >
                            <div className={commoncss.dFlexClm}>
                              <span className={wsCreationcss.wscLabel2}>
                                {CompanyType(det, "name")}
                              </span>
                              <span className={wsCreationcss.wscLabel3}>
                                {CompanyType(det, "company_type")}
                              </span>
                              <span className={wsCreationcss.wscLabel3}>
                                {CompanyType(det)}
                              </span>
                            </div>
                            <div className="d-flex" style={{ gap: "20px" }}>
                              <div className={wsCreationcss.wscCard2}>
                                <span className={wsCreationcss.wscLabel4}>
                                  Current Year
                                </span>
                                <span className={wsCreationcss.wscLabel5}>
                                  {moment(
                                    CompanyType(det, "current_yr")
                                  ).format("DD MMM YYYY")}
                                </span>
                              </div>
                              <div className={wsCreationcss.wscCard2}>
                                <span className={wsCreationcss.wscLabel4}>
                                  Previous Year
                                </span>
                                <span className={wsCreationcss.wscLabel5}>
                                  {moment(
                                    CompanyType(det, "previous_yr")
                                  ).format("DD MMM YYYY")}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    <div className="m-2" hidden>
                      {insideWorskpace === "no" ? (
                        <PaginationRounded
                          data={
                            pageData.all_project?.length > 0 &&
                            pageData.all_project
                          }
                          setData={setAllProject}
                        />
                      ) : (
                        <PaginationRounded
                          data={
                            presetsData.all_presets.length > 0 &&
                            presetsData.all_presets
                          }
                          setData={setOneCheckWorkspace}
                        />
                      )}
                    </div>
                  </>
                )}

                {activeSection === "Fixed Assets" && (
                  <>
                    {insideWorskpace === "no" &&
                       fixedAssetData.all_fixedAssets.length > 0 &&
                       fixedAssetData.all_fixedAssets.map((fixedAsset) => {
                        return (
                          <div
                            key={fixedAsset._id}
                            className="d-flex px-4 py-1"
                            style={{ "align-items": "center" }}
                          >
                            <div
                              className={`${commoncss.dFlexJustifysb}`}
                              style={{
                                width: "100%",
                                "margin-bottom": "10px",
                                "margin-top": "10px",
                              }}
                            >
                              <div className={commoncss.dFlexClm}>
                                <span
                                  className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                  onClick={() => {
                                    handleClickNew(
                                      `/myfinV2/fixedAsset/listing/${fixedAsset._id}/${fixedAsset.companyID}`
                                    );
                                  }}
                                >
                                  {fixedAsset.name}
                                </span>
                                <span className={wsCreationcss.wscLabel3}>
                                  {fixedAsset.companyData?.company_name}
                                </span>
                              </div>
                              <div className="d-flex" style={{ gap: "20px" }}>
                                <div className={wsCreationcss.wscCard2}>
                                  <span className={wsCreationcss.wscLabel9}>
                                    As on date
                                  </span>
                                  <span className={wsCreationcss.wscLabel5}>
                                    {moment(fixedAsset.asOnDate).format(
                                      "DD MMM YYYY"
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    {insideWorskpace === "yes" &&
                      checkFixedAssetdata.length > 0 &&
                      checkFixedAssetdata.map((fixedAsset) => {
                        return (
                          <div
                            key={fixedAsset}
                            className="d-flex px-4 py-1"
                            style={{ "align-items": "center" }}
                          >
                            <div
                              className={`${commoncss.dFlexJustifysb}`}
                              style={{
                                width: "100%",
                                "margin-bottom": "10px",
                                "margin-top": "10px",
                              }}
                            >
                              <div className={commoncss.dFlexClm}>
                                <span
                                  className={`${wsCreationcss.wscLabel2} ${commoncss.clickable}`}
                                  onClick={() => {
                                    handleClickNew(
                                      `/myfinV2/fixedAsset/listing/${fixedAsset}/${FixedAssetName(
                                        fixedAsset,
                                        "company"
                                      )}`
                                    );
                                  }}
                                >
                                  {FixedAssetName(fixedAsset, "name")}
                                </span>
                                <span className={wsCreationcss.wscLabel3}>
                                  {FixedAssetName(fixedAsset, "company")}
                                </span>
                              </div>
                              <div className="d-flex" style={{ gap: "20px" }}>
                                <div className={wsCreationcss.wscCard2}>
                                  <span className={wsCreationcss.wscLabel9}>
                                    As on date
                                  </span>
                                  <span className={wsCreationcss.wscLabel5}>
                                    {moment(
                                      FixedAssetName(fixedAsset, "asOnDate")
                                    ).format("DD MMM YYYY")}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    <div className="m-2" hidden>
                      {insideWorskpace === "no" ? (
                        <PaginationRounded
                          data={
                            fixedAssetData.all_fixedAssets.length > 0 &&
                            fixedAssetData.all_fixedAssets
                          }
                          setData={setFixedAsset}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>


            {activeSection === "Book Closure" && (
              <>
                <TableContainer component={Paper}>
                  <Table
                    style={{ marginBottom: "0px" }}
                    sx={{}}
                    aria-label="caption table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>BOOK CLOSURE REGISTER NAME</TableCell>
                        <TableCell>PARENT COMPANY</TableCell>
                        <TableCell align="center">ACTION</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <>
                        {newData.length > 0 &&
                          newData.map((invest) => {
                            return (
                              <>
                                <TableRow>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                      textDecoration: "underline",
                                      color: "#03565a",
                                      cursor: "pointer",
                                      backgroundColor: "white",
                                    }}
                                    onClick={() => detailsIr(invest._id)}
                                  >
                                    <span className="font-sans">
                                      {IRName(invest._id, "name")}
                                    </span>
                                  </TableCell>

                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <span className="font-sans">
                                      {IRName(invest._id, "company")}
                                    </span>
                                  </TableCell>

                                  <TableCell
                                    style={{ backgroundColor: "white" }}
                                    align="center"
                                  >
                                    <MoreVertIcon
                                      onClick={(e) =>
                                        handleClick(
                                          e,
                                          IRName(invest._id, "id"),
                                          invest._id
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                    />
                                    <Popover
                                      id={id}
                                      open={open}
                                      anchorEl={anchorEl3}
                                      onClose={handleClose}
                                      anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "left",
                                      }}
                                    >
                                      <Typography sx={{ p: 2 }}>
                                        {/* <span
                                        className="font-sans"
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "12px",
                                        }}
                                        onClick={() => {
                                          handleShareScreen(IrDataID);
                                        }}
                                      >
                                        Share
                                      </span>
                                      <br /> */}
                                        <span
                                          className="font-sans"
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "12px",
                                          }}
                                          onClick={() => {
                                            handleDuplicate(IrDataID);
                                          }}
                                        >
                                          Duplicate
                                        </span>
                                        <br />
                                        {/* <span
                                        className="font-sans"
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "12px",
                                        }}
                                      >
                                        Extract
                                      </span>
                                      <br /> */}
                                      </Typography>
                                    </Popover>
                                  </TableCell>
                                </TableRow>
                              </>
                            );
                          })}
                        {userAccessIr()?.length > 0 &&
                          userAccessIr()?.map((invest) => {
                            return (
                              <>
                                <TableRow>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                      textDecoration: "underline",
                                      color: "#03565a",
                                      cursor: "pointer",
                                      backgroundColor: "white",
                                    }}
                                    onClick={() => detailsIr(invest[0]?._id)}
                                  >
                                    {IRNameIR(invest[0]?._id, "name")}
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <span>
                                      {IRNameIR(invest[0]?._id, "company")}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    style={{ backgroundColor: "white" }}
                                    align="center"
                                  >
                                    <MoreVertIcon
                                      onClick={(e) =>
                                        handleClick(
                                          e,
                                          IRNameIR(invest[0]?._id, "id"),
                                          invest[0]?._id
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                    />
                                    <Popover
                                      id={id}
                                      open={open}
                                      anchorEl={anchorEl3}
                                      onClose={handleClose}
                                      anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "left",
                                      }}
                                    >
                                      <Typography sx={{ p: 2 }}>
                                        {/* <span
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "12px",
                                        }}
                                        onClick={() => {
                                          handleShareScreen(IrDataID);
                                        }}
                                      >
                                        Share
                                      </span>
                                      <br /> */}
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "12px",
                                          }}
                                        >
                                          Duplicate
                                        </span>
                                        <br />
                                        {/* <span
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "12px",
                                        }}
                                      >
                                        Extract
                                      </span>
                                      <br /> */}
                                        {/* <span
                                        onClick={() => handleAddIR(IrDataID)}
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "12px",
                                        }}
                                      >
                                        Add More IR
                                      </span> */}
                                      </Typography>
                                    </Popover>
                                  </TableCell>
                                </TableRow>
                              </>
                            );
                          })}
                      </>
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
          </div>
        </div>
      ) : (
        <></>
        // <Card style={{ height: "324px" }}>
        //   <Card.Header className="ir-empty-cardheader">
        //     <Table sx={{}} aria-label="caption table">
        //       <TableHead>
        //         <TableRow>
        //           <TableCell>REGISTER NAME </TableCell>
        //           <TableCell align="left">COMPANY NAME</TableCell>
        //           <TableCell align="center">CURRENT YEAR</TableCell>
        //           <TableCell align="center">PREVIOUS YEAR</TableCell>
        //           <TableCell align="center">ACTION</TableCell>
        //         </TableRow>
        //       </TableHead>
        //     </Table>
        //   </Card.Header>
        //   <Card.Body style={{ textAlign: "center" }}>
        //     <Card.Title>
        //       <img src={DashboardLogo} alt="logo" />
        //     </Card.Title>
        //     <Card.Text style={{ textAlign: "center" }}>
        //       There are no registers created
        //     </Card.Text>
        //     <Button className="wp-btn-fill" onClick={handleRegisterModalOpen}>
        //       <AddIcon /> Create register
        //     </Button>
        //     &nbsp; &nbsp;
        //     <Button className="wp-btn-no-fill">
        //       <CloudIcon /> Upload register
        //     </Button>
        //     <div
        //       style={{
        //         textAlign: "center",
        //       }}
        //     ></div>
        //   </Card.Body>
        // </Card>
      )}

      {/* <InvestmentModal
        openInvest={openInvest}
        handleClose={handleCloseModal}
        continueStep={continueStep}
      /> */}
      {registerModalOpen && (
        <RegisterModal
          registerModalOpen={registerModalOpen}
          handleRegisterModalClose={handleRegisterModalClose}
          continueStep={nextStep}
          activePlandata={activePlandata}
        />
      )}
      <Modal
        open={openRenameModal}
        onClose={handleCloseRenameModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styles}>
          <div className="col-12">
            <h5>Rename Investment Register</h5>
            <form>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  value={updatedIRName}
                  onChange={(e) => handleRenameIr(e)}
                />
              </div>
              <input
                type="button"
                className="btn btn-primary1"
                value="Submit"
                onClick={() => RenameIR()}
              />
              <input
                type="button"
                className="btn btn-defult"
                value="Close"
                onClick={handleCloseRenameModal}
              />
            </form>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default IRTab;
